import React from "react";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

import { Input } from "semantic-ui-react";

import useDateInputFormatter from "./hooks/useDateInput";
import { QuickLinks } from "./components";

export function DatePickerInput({
  defaultDate,
  showQuickLink,
  onChange,
  formatString,
  showTimeSelect,
  ...props
}) {
  const { dateString, date, updateDate, updateDateString } =
    useDateInputFormatter(defaultDate, onChange, formatString);

  return (
    <React.Fragment>
      {showQuickLink && <QuickLinks onClick={updateDate} />}
      <Input
        data-test="datepicker-input"
        fluid
        style={{ marginBottom: "1em" }}
        placeholder={`e.g. 02/04/2022${showTimeSelect ? ", 6:45 PM" : ""}`}
        value={dateString}
        onChange={(_, { value }) => {
          updateDateString(value);
        }}
      />
      <DatePicker
        onChange={updateDate}
        selected={date}
        {...props}
        inline
        showTimeSelect={showTimeSelect}
        timeIntervals={15}
        showYearDropdown
        scrollableYearDropdown
      />
    </React.Fragment>
  );
}

DatePickerInput.propTypes = {
  defaultDate: PropTypes.instanceOf(Date),
  formatString: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showQuickLink: PropTypes.bool,
  showTimeSelect: PropTypes.bool,
};

DatePickerInput.defaultProps = {
  defaultDate: null,
  showQuickLink: false,
  showTimeSelect: true,
  formatString: "MM/dd/yyyy, h:mm a",
};

export default DatePickerInput;
